import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFarmOrganicFertilizerProduction } from "services";

import { GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, GET_FARM_ORGANIC_FERTILIZER_PRODUCTION, UPDATE_FARM_ORGANIC_FERTILIZER_PRODUCTION } from "consts";

export const useUpdateFarmOrganicFertilizerProduction = ({ farmId, year: _year }: { farmId: string; year: number }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId],
    mutationFn: updateFarmOrganicFertilizerProduction,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId] });
    },
  });
};
